export default __webpack_public_path__ + "static/media/stationary.df764c86.png";